export default __webpack_public_path__ + "static/media/wallstreetLogo.6963d874.webp";